<template>
    <f7-list media-list style="margin:0px;height:100%;overflow:auto;">
        <f7-list-item v-for="(ep, index) in datos" @click="verEpisodio(ep)"
                      link="#"
                      :key="index"
                      :title="ep.Nombre"
                      :subtitle="'Disponible ' + ep.Episodio">
            <img slot="media" :src="ep.Imagen" width="80"/>
        </f7-list-item>
    </f7-list>
</template>

<script>
    export default {
        props: ['datos'],
        data() {
            return {}
        },
        methods: {
            verEpisodio(ep) {

                let botones = [];
                let self = this;

                if (ep.Directo) {
                    botones.push({
                        text: 'Ver Episodio', onClick: function () {
                            self.$f7router.navigate('/anime/' + ep.idAnime + "/episodio/" + ep.idEpisodio, {})
                        }
                    });
                }
                botones.push({
                    text: 'Ver Ficha', onClick: function () {
                        self.$f7router.navigate('/anime/' + ep.idAnime, {})
                    }
                });
                botones.push({
                    text: 'Cancelar', onClick: function () {
                    }
                });
                this.$f7.dialog.create({
                    title: 'Servidor',
                    text: 'Por favor, escoja el servidor que desea utilizar para reproducir.',
                    buttons: botones,
                    verticalButtons: true,
                }).open();

            },

        },
        mounted() {

        }
        ,
    }
</script>
